export default "__VITE_ASSET__ZqJ26uJ4__"